import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardActionArea, CardContent, Typography } from '@material-ui/core';
// import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { indigo } from '@material-ui/core/colors';
import LazyImg from './LazyImg'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    cardRoot: {
        width: "100%",
        height: '100%',
        [theme.breakpoints.only('xs')]: {
            position: 'relative'
        },
    },
    serviceMedia: {
        '& div': {
            paddingBottom: '50%',
            [theme.breakpoints.only('xs')]: {
                paddingBottom: theme.spacing(12),
            },
        },
    },
    imgGrad: {
        display: 'none',
        [theme.breakpoints.only('xs')]: {
            display: 'block',
            position: "absolute",
            top: 0,
            height: theme.spacing(12),
            width: '100%',
            background: 'linear-gradient(to bottom, transparent, #0000009e)'
        },
    },
    titleContainer: {
        display: 'flex',
        [theme.breakpoints.only('xs')]: {
            position: 'absolute',
            width: '100%',
            height: theme.spacing(10),
            top: theme.spacing(-13),
            textShadow: '1px 1px 2px #0000009e'
        }
    },
    cardTitle: {
        flexGrow: 1,
        color: indigo[500],
        [theme.breakpoints.only('xs')]: {
            color: '#fff',
            marginTop: 'auto'
        }
    },
    linkArrow: {
        marginTop: theme.spacing(0.75),
        color: indigo[500],
        fontSize: 18,
        [theme.breakpoints.only('xs')]: {
            color: '#fff',
            marginTop: 'auto',
            paddingBottom: theme.spacing(1.75)
        }
    }
}))

export default function ServiceCard({ heading, ph, src, link, children }) {
    const classes = useStyles();
    const history = useHistory();

    return (
        <Card className={classes.cardRoot}>
            <div className={classes.serviceMedia}>
                <LazyImg placeholder={ph}
                    srcSet={`${src[0]} 400w, ${src[1]} 750w, ${src[2]} 1250w`}
                    sizes="(max-width: 600px): 100vw, (max-width: 960px): 50vw, (max-width: 1280): 33.33vw, 25vw"
                />
            </div>
            <div className={classes.imgGrad}></div>
            <CardContent>
                <CardActionArea onClick={e => history.push(`/services${link}`)}>
                    <div className={classes.titleContainer}>
                        <Typography
                            className={classes.cardTitle}
                            gutterBottom variant="h6"
                            component="h3"
                        >
                            {heading}
                        </Typography>
                        <ArrowForwardIosIcon className={classes.linkArrow} />
                    </div>
                </CardActionArea>
                <div>
                    {children}
                </div>
            </CardContent>
        </Card>
    )
}